import { render, staticRenderFns } from "./PessoaConexao.vue?vue&type=template&id=06433648"
import script from "./PessoaConexao.vue?vue&type=script&lang=js"
export * from "./PessoaConexao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports